import {JSONAttrs, JSONContent} from '../types';
import {getTextAlign} from '../utils';
import {useBuildContent} from 'hooks/guidebooks/useBuildContent';
import {MainText, SecondaryText} from '../styled';

type Props = {
  level?: number;
  content: JSONContent[];
  attrs?: JSONAttrs;
};

function Paragraph({level, content, attrs}: Props) {
  const builtContent = useBuildContent(content);

  switch (level) {
    case 1:
      return <MainText style={{textAlign: getTextAlign(attrs)}}>{builtContent}</MainText>;
    case 2:
      return (
        <SecondaryText style={{textAlign: getTextAlign(attrs)}}>
          {builtContent}
        </SecondaryText>
      );
    default:
      return <p style={{textAlign: getTextAlign(attrs)}}>{builtContent}</p>;
  }
}

export {Paragraph};
